import { Injectable } from '@angular/core';

import { Specification } from '../definition/specification';
import { UserRoleEnum } from 'app/shared/enums';

@Injectable()
export class ExecutiveUsersSpec extends Specification<UserRoleEnum | undefined> {
	// skipcq: JS-0105
	IsSatisfiedBy(candidate?: UserRoleEnum): boolean {
		if (candidate === undefined) {
			return false;
		}
		return candidate === UserRoleEnum.Admin
	}
}
